"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useOption = useOption;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@mui/utils");
var _extractEventHandlers = require("../utils/extractEventHandlers");
var _useList = require("../useList");
var _useCompound = require("../useCompound");
var _useButton = require("../useButton");
var _combineHooksSlotProps = require("../utils/combineHooksSlotProps");
/**
 *
 * Demos:
 *
 * - [Select](https://mui.com/base-ui/react-select/#hooks)
 *
 * API:
 *
 * - [useOption API](https://mui.com/base-ui/react-select/hooks-api/#use-option)
 */ function useOption(params) {
    var value = params.value, label = params.label, disabled = params.disabled, optionRefParam = params.rootRef, idParam = params.id;
    var _ref = (0, _useList.useListItem)({
        item: value
    }), getListItemProps = _ref.getRootProps, highlighted = _ref.highlighted, selected = _ref.selected;
    var _ref1 = (0, _useButton.useButton)({
        disabled: disabled,
        focusableWhenDisabled: true
    }), getButtonProps = _ref1.getRootProps, buttonRefHandler = _ref1.rootRef;
    var id = (0, _utils.unstable_useId)(idParam);
    var optionRef = React.useRef(null);
    var selectOption = React.useMemo(function() {
        return {
            disabled: disabled,
            label: label,
            value: value,
            ref: optionRef,
            id: id
        };
    }, [
        disabled,
        label,
        value,
        id
    ]);
    var index = (0, _useCompound.useCompoundItem)(value, selectOption).index;
    var handleRef = (0, _utils.unstable_useForkRef)(optionRefParam, optionRef, buttonRefHandler);
    var createHandleKeyDown = function(otherHandlers) {
        return function(event) {
            var _otherHandlers_onKeyDown;
            (_otherHandlers_onKeyDown = otherHandlers.onKeyDown) === null || _otherHandlers_onKeyDown === void 0 ? void 0 : _otherHandlers_onKeyDown.call(otherHandlers, event);
            if (event.defaultMuiPrevented) {
                return;
            }
            if ([
                ' ',
                'Enter'
            ].includes(event.key)) {
                event.defaultMuiPrevented = true; // prevent listbox onKeyDown
            }
        };
    };
    var getOwnHandlers = function() {
        var otherHandlers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return {
            onKeyDown: createHandleKeyDown(otherHandlers)
        };
    };
    return {
        getRootProps: function() {
            var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var externalEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(externalProps);
            var getCombinedRootProps = (0, _combineHooksSlotProps.combineHooksSlotProps)(getListItemProps, (0, _combineHooksSlotProps.combineHooksSlotProps)(getButtonProps, getOwnHandlers));
            return _object_spread_props(_object_spread({}, externalProps, externalEventHandlers, getCombinedRootProps(externalEventHandlers)), {
                id: id,
                ref: handleRef,
                role: 'option',
                'aria-selected': selected
            });
        },
        highlighted: highlighted,
        index: index,
        selected: selected,
        rootRef: handleRef
    };
}
